export const useExprToVids = (useExpr) => {
    if (Array.isArray(useExpr.expr)) {
        return useExpr.expr.flatMap(expr => {
            const scope = [...useExpr.scope, ...expr.scope];
            return useExprToVids({ ...useExpr, scope, expr: expr.expr });
        });
    }
    else if (useExpr.expr.value === 'self') {
        const vid = { names: useExpr.scope.map(n => n.value) };
        return [{ vid, useExpr }];
    }
    else {
        const vid = { names: [...useExpr.scope.map(n => n.value), useExpr.expr.value] };
        return [{ vid, useExpr }];
    }
};
//# sourceMappingURL=use-expr.js.map